import { diffRoles } from "./role";
import { diffAllowances } from "./allowances";
import { merge } from "./helpers";
export function diffAll({ prev, next, }) {
    return merge(diffRoles({
        prev: prev?.roles,
        next: next?.roles,
    }), diffAllowances({
        prev: prev?.allowances,
        next: next?.allowances,
    }));
}
